import { combineReducers } from "redux";
import { firebaseReducer } from "react-redux-firebase";
import { reducer as toastrReducer } from "react-redux-toastr";
import authReducer from "./authReducer";
import bookingPaymentReducer from "./bookingPaymentReducer";
import bookingReducer from "./bookingReducer";
import addressReducer from "./addressReducer";
import loadingReducer from "./loadingReducer";
import tempDataReducer from "./tempDataReducer";
import quoteReducer from "./quoteReducer";
import locationReducer from "./locationReducer";
import couponReducer from "./couponReducer";
import pageReducer from "./pageReducer";
import vipReducer from "./vipReducer";
import reviewReducer from "./reviewReducer";
import configReducer from "./configReducer";
import aggregateReducer from "./aggregateReducer";
import trackersReducer from "./trackersReducer";
import pricingReducer from "./pricingReducer";
import abTestReducer from "./abTestReducer";
import notificationReducer from "./notificationReducer";
import invoicesReducer from "./invoicesReducer";
import variablesReducer from "./variablesReducer";
import uiReducer from "./uiReducer";
import itemsReducer from "./itemsReducer";
import dumpSitesReducer from "./dumpSitesReducer";
import bookingQuotesReducer from "./bookingQuotesReducer";
import businessAccountsReducer from "./businessAccountsReducer";
import userReducer from "./userReducer";
import salesGoalsReducer from "./salesGoalsReducer";
import bookingBidsReducer from "./bookingBidsReducer";
import penaltyPointsReducer from "./penaltyPointsReducer";
import analyticsReducer from "./analytics";
import attributesReducer from "./attributesReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  notificationSettings: notificationReducer,
  bookingPayment: bookingPaymentReducer,
  booking: bookingReducer,
  bookingQuote: bookingQuotesReducer,
  bookingBid: bookingBidsReducer,
  businessAccount: businessAccountsReducer,
  address: addressReducer,
  firebase: firebaseReducer,
  loader: loadingReducer,
  tempData: tempDataReducer,
  quote: quoteReducer,
  serviceLocations: locationReducer,
  toastr: toastrReducer,
  coupon: couponReducer,
  page: pageReducer,
  vip: vipReducer,
  review: reviewReducer,
  config: configReducer,
  aggregates: aggregateReducer,
  tracking: trackersReducer,
  pricing: pricingReducer,
  abTest: abTestReducer,
  invoice: invoicesReducer,
  variables: variablesReducer,
  ui: uiReducer,
  dropDownItems: itemsReducer,
  dumpSite: dumpSitesReducer,
  user: userReducer,
  sales: salesGoalsReducer,
  penaltyPoints: penaltyPointsReducer,
  analytics: analyticsReducer,
  attributes: attributesReducer,
});

export default rootReducer;
